import React, { useRef, useState, useEffect} from 'react';
import { useServiceContext } from '../../components/Context/ServiceContext';
import ServiceView from '../../views/PartnerView/ServiceView';
import AboutPage from '../../views/AboutPage';


const ServiceComponent = () => {

    const userType = localStorage.getItem('userType'); 
    const data = useRef('');
    const [loading,setLoading] = useState(true);
    const didFetch = useRef(false); 

    const error = useRef('');
    const { service, partnerservice, GetServices, GetPartnerServices } = useServiceContext();
    const getData = async () => {
        
        try {
             
    //         const response = await fetchPartner();
    //         data.current = response.data;
                if(userType==='ADMIN')
                {
                    await GetServices();
                }
                else
                {
                    await GetPartnerServices();
                }
                setLoading(false); // Set loading to false once data is fetched
    //          
    //         console.log(response.data);
        
        } catch (error) {
            console.error('Error fetching data:', error);
            error.current= 'Failed to fetch data.';
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
          getData();    
          didFetch.current = true; // Mark the API call as done
        }
      });
    
    return (
        <div>{/*{loading && <div>Loading...</div>}*/}
        {!loading && (service!=null || partnerservice!=null) && <ServiceView />}
        </div>
    // 
    // 
    )
    // return <ServiceView Servicesdata={service} />
   
};

export default ServiceComponent;
